import { HttpClientModule } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GenericService } from './shared/services/generic.services/generic.service';
import { MatDialog } from '@angular/material/dialog';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { NetworkStatusComponent } from './shared/components/network-status/network-status.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HttpClientModule, NetworkStatusComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private gen: GenericService,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.gen.loaderState.subscribe({
      next: (res) => {
        if (res == true) {
          this.dialog.open(LoaderComponent, {
            width: '0px',
            height: '0px',
            hasBackdrop: true,
            disableClose: true,
            backdropClass: 'custom-dialog-backdrop',
          });
        }
        this.cd.markForCheck();
      },
    });
  }
  title = `NSC's Budget Master`;
}
